export default function CaretRightIcon() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="31" height="31" rx="3.5" fill="white" />
      <rect x="0.5" y="0.5" width="31" height="31" rx="3.5" stroke="#D7DFE9" />
      <path
        d="M14.94 12L14 12.94L17.0533 16L14 19.06L14.94 20L18.94 16L14.94 12Z"
        fill="#455468"
      />
    </svg>
  );
}
